export function isDef(value) {
  return value !== null && value !== undefined
}